import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Akira Expanded (display font) ships without accented glyphs. Decomposing to NFD keeps the
 * base letter in Akira and lets the browser draw only the accent mark from the fallback font.
 */
export function display(text: string): string {
  return text.normalize("NFD");
}

/**
 * "A L D O" → "ALDO". Some athletes type (or dictate) their name one letter at a time; only a value
 * made entirely of single characters separated by single spaces is joined, so "Ana María" is left alone.
 * Checked in NFC so a decomposed "Í" (I + combining accent) still counts as one letter.
 */
const SPACED_LETTERS = new RegExp("^(\\S )+\\S$", "u"); // RegExp(): the "u" literal flag needs an ES6 target
export function joinSpacedLetters(text: string): string {
  const t = text.trim();
  const nfc = t.normalize("NFC");
  return SPACED_LETTERS.test(nfc) ? nfc.replace(/ /g, "") : t;
}

/** "70001234" → "7000-1234", the usual Salvadoran phone notation. */
export function formatPhone(digits: string): string {
  return (digits ?? "").replace(/\D/g, "").replace(/(\d{4})(?=\d)/g, "$1-");
}
